/* global module, require */
const crel = require('./createElement'),
	empty = require('./emptyElement');

function PlannerSummary(parent, onRequest) {
	this.name = 'Summary';
	this.parent = parent;
	this.planner = parent.planner;
	this.measurements = parent.measurements;
	this.options = parent.options;
	this.details = parent.details;

	this.complete = () => true;
	this.container = crel({ className: 'planner-show-summary' });
	crel({
		_tag: 'h3',
		_parent: this.container,
		innerText:
			'Once your quote has been calculated you will be emailed a PDF of your quote.',
	});

	this.style = this.addItem('Style:');
	this.use = this.addItem('Use:');
	this.dimensions = this.addItem('Dimensions:');

	crel({
		_tag: 'h3',
		_parent: this.container,
		innerText:
			'We guarantee to beat any like-for-like quote. Installation available; please ask for price & availability.',
	});

	this.parent.addPrevious(this.container);

	crel({
		_tag: 'button',
		_parent: this.container,
		className: 'action-btn',
		innerText: 'Request a Quote',
		onclick: () => onRequest(),
	});
}

PlannerSummary.prototype.activate = function() {
	this.style.innerText = this.planner.style.name.replace('\n', ', ');
	this.use.innerText = this.options.options.installation;
	this.dimensions.innerText = this.parseDimensions(this.measurements.data);

	empty(this.parent.content);
	this.parent.content.appendChild(this.container);

	// we're handling the previous/next buttons ourselves
	this.previous = null;
	this.hidePlaceBtn = true;
};

PlannerSummary.prototype.addItem = function(innerText) {
	crel({
		className: 'label',
		_parent: this.container,
		innerText,
	});
	return crel({ className: 'data', _parent: this.container, innerText: '-' });
};

PlannerSummary.prototype.parseDimensions = function(data) {
	const parts = data.map(item => {
		if (item.angle) {
			if (item.angle < 180) return `${item.length}mm at ${item.angle}° left`;
			return `${item.length}mm at ${360 - item.angle}° right`;
		}
		return `${item.length}mm`;
	});

	return parts.join('\n');
};

module.exports = PlannerSummary;
